/* eslint-disable camelcase */
import React from 'react';
import ListItemText from '@mui/material/ListItemText';
import { SystemRecordTypeEnum } from '../record-viewer/types';
import RecordKeyDates from '../record-viewer/record-key-dates';

interface Props {
  issue: Record<string, any>,
}

const RECORD_ISSUE_TITLE = 'b392';

const IssuePickerItem: React.FC<Props> = ({
  issue,
}) => {
  const { [RECORD_ISSUE_TITLE]: title } = issue.form_values;
  const { created_at } = issue;
  const systemRecordType = SystemRecordTypeEnum.Issues;
  return (
    <ListItemText
      disableTypography
      primary={title}
      secondary={(
        <RecordKeyDates
          createdAt={created_at}
          systemRecordType={systemRecordType}
        />
      )}
    />
  );
};

export default IssuePickerItem;
